const FrenchFlag = 'https://qonto-assets.s3.eu-central-1.amazonaws.com/homepage/icons/fr.svg';
const SpanishFlag = 'https://qonto-assets.s3.eu-central-1.amazonaws.com/homepage/icons/es.svg';
const ItalianFlag = 'https://qonto-assets.s3.eu-central-1.amazonaws.com/homepage/icons/it.svg';
const GermanFlag = 'https://qonto-assets.s3.eu-central-1.amazonaws.com/homepage/icons/de.svg';
const ArrowDown = 'https://qonto-assets.s3.eu-central-1.amazonaws.com/homepage/icons/arrow-down.svg';
const Online = 'https://qonto-assets.s3.eu-central-1.amazonaws.com/homepage/icons/online.svg';

// ABTEST CATCH TRAFFIC
window.addEventListener('DOMContentLoaded', (_event) => {
  const baseContent = {
    fr: {
      title: 'Il semblerait que vous parliez ',
      mainText: 'Sachez que nos services varient d’un pays à l’autre.',
      secondaryBtn: 'Stay on the English website',
      primaryBtn: 'Passer en français ',
      defaultDropdownValue: `<div style="margin-right: 14px"><img src=${FrenchFlag} style="border-radius:35px; height: 18px; width: 18px; object-fit: cover"></div> <div>Français</div>`,
      countryName: `<div style="margin-right: 14px"><img src=${FrenchFlag} style="border-radius:35px; height: 18px; width: 18px; object-fit: cover"></div> <div>France</div>`,
    },
    es: {
      title: 'Parece que hablas',
      mainText: 'Ten en cuenta que el servicio cambia según el país.',
      secondaryBtn: 'Stay on the English website',
      primaryBtn: 'Ir a la web en Español',
      defaultDropdownValue: `<div style="margin-right: 14px"><img src=${SpanishFlag} style="border-radius:35px; height: 18px; width: 18px; object-fit: cover"></div> <div>Español</div>`,
      countryName: `<div style="margin-right: 14px"><img src=${SpanishFlag} style="border-radius:35px; height: 18px; width: 18px; object-fit: cover"></div> <div>España</div>`,
    },
    it: {
      title: 'Sembra che la tua lingua sia',
      mainText: 'Tieni a mente che i nostri prodotti cambiano in base al Paese.',
      secondaryBtn: 'Stay on the English website',
      primaryBtn: 'Passa al sito italiano',
      defaultDropdownValue: `<div style="margin-right: 14px"><img src=${ItalianFlag} style="border-radius:35px; height: 18px; width: 18px; object-fit: cover"></div> <div>Italiano</div>`,
      countryName: `<div style="margin-right: 14px"><img src=${ItalianFlag} style="border-radius:35px; height: 18px; width: 18px; object-fit: cover"></div> <div>Italia</div>`,
    },
    de: {
      title: 'Es sieht so aus, als sprächen Sie',
      mainText: 'Bitte beachten Sie, dass unsere Produkte länderspezifisch sind',
      secondaryBtn: 'Stay on the English website',
      primaryBtn: 'Zur deutschen Website wechseln',
      defaultDropdownValue: `<div style="margin-right: 14px"><img src=${GermanFlag} style="border-radius:35px; height: 18px; width: 18px; object-fit: cover"></div> <div>Deutsch</div>`,
      countryName: `<div style="margin-right: 14px"><img src=${GermanFlag} style="border-radius:35px; height: 18px; width: 18px; object-fit: cover"></div> <div>Deutschland</div>`,
    },
    en: {
      title: 'Select your region',
      mainText: 'Please keep in mind that some of our products vary from country to country.',
      secondaryBtn: 'Stay on the English website',
      primaryBtn: 'Change website language',
      defaultDropdownValue: `<div style="margin-right: 14px"><img src=${Online} style="border-radius:35px; height: 18px; width: 18px; object-fit: cover"></div> <div>Select your region</div>`,
      countryName: `<div style="margin-right: 14px"><img src=${Online} style="border-radius:35px; height: 18px; width: 18px; object-fit: cover"></div> <div>Select your region</div>`,
    }
  };

  const generateItems = (currentLocale) => {
    if (currentLocale != 'en') {
      return Object.keys(baseContent).map((countryCode) => {
        if (countryCode != currentLocale && countryCode != 'en') {
          return (
            `<li data-locale=${countryCode} class="dropdown-item bg-primary-white flex w-full items-center body-small">
              ${baseContent[countryCode].defaultDropdownValue}
            </li>`
          )
        }
      }).join('')
    } else {
      return Object.keys(baseContent).map((countryCode) => {
        if (countryCode != currentLocale) {
          return (
            `<li data-locale=${countryCode} class="dropdown-item bg-primary-white flex w-full items-center body-small">
              ${baseContent[countryCode].countryName}
            </li>`
          )
        }
      }).join('')
    }
  }

  const loadCatchTrafficModal = (currentLocale, options = {}) => {
    const content = baseContent[currentLocale]

    document.querySelectorAll('.base-page')[0].insertAdjacentHTML('afterbegin', `<div id="abtest-black-layer"></div>`)
    document.querySelectorAll('.base-page')[0].insertAdjacentHTML('afterbegin', `
      <div id="abtest-catch-traffic-modal" class="fixed bg-primary-white rounded-8 ${options['animation']}" style="z-index: 999; box-shadow: 0px 6px 24px rgba(28, 15, 125, 0.12);">
        <div class="flex justify-between">
          <h3 class="mb-16 text-center md:text-left">
            ${content.title}:
          </h3>

          <div data-locale="closedForever" class="abtest-catch-traffic-close cursor-pointer" style="margin-top: -9px">
            <svg width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/3000/svg">
              <path d="M1 1L19 19" stroke="#1D1D1B" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1 19L19 1" stroke="#1D1D1B" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </div>

        <div class="mb-16">
          <div>
            <ul id="abtest-dropdown" class="cursor-pointer w-full">
              <div id="selected-value-wrapper" class="secondary w-full flex justify-between items-center" style="padding: 6px 22px">
                <li class="selected flex items-center body-small">${content.defaultDropdownValue}</li>
                <div><img src="${ArrowDown}"/></div>
              </div>

              <div id="options-block" class="bg-primary-white hidden mt-10 rounded-4" style="box-shadow: 0px 4px 24px rgba(28, 15, 125, 0.12); padding: 9px 22px">
                ${generateItems(currentLocale)}
              </div>
            </ul>
          </div>
        </div>

        <div class="mb-16 text-14 ">
          ${content.mainText}
        </div>

        <div class="flex-col md:flex-row">
          <div data-locale=${currentLocale} class="secondary md:mr-8 mb-8 md:mb-0 cursor-pointer abtest-catch-traffic-close">
            ${content.secondaryBtn}
          </div>
          <div id="change-website-language" data-locale=${currentLocale} class="${currentLocale === 'en' ? 'btn-disabled' : ''} primary md:ml-8 cursor-pointer">
            ${content.primaryBtn}
          </div>
        </div>
      </div>
    `)

    // Consts
    const closeBtns = document.getElementsByClassName('abtest-catch-traffic-close');
    const modal = document.getElementById('abtest-catch-traffic-modal');
    const darkOverlay = document.getElementById('abtest-black-layer');
    const optionsBlock = document.getElementById('options-block');
    const selectedValueWrapper = document.getElementById('selected-value-wrapper');
    const dropdownItems = document.getElementsByClassName('dropdown-item');
    const changeLanguageBtn = document.getElementById('change-website-language');

    // Close the modal when clicking on the closing cross.
    Array.from(closeBtns).map((btn) => {
      btn.addEventListener('click', (_event) => {
        localStorage.setItem("modalClosed", btn.dataset.locale);
        modal.classList.add('hidden');
        darkOverlay.classList.add('hidden');
      })
    })

    // Add event on the dropdown items.
    Array.from(dropdownItems).map((item) => {
      item.addEventListener('click', (_event) => {
        modal.parentElement.removeChild(modal);
        darkOverlay.parentElement.removeChild(darkOverlay);
        loadCatchTrafficModal(item.dataset.locale)
      })
    })

    // Redirect the user on a new page when he wants to change the language.
    changeLanguageBtn.addEventListener('click', (_event) => {
      if (changeLanguageBtn.dataset.locale === 'en') {
        return;
      } else {
        localStorage.setItem("modalClosed", changeLanguageBtn.dataset.locale);
        const url = window.location.href.split('/');
        url[3] = changeLanguageBtn.dataset.locale;
        window.location.href = url.join('/');
      }
    })

    // Add event on click to toggle the options of the dropdown.
    selectedValueWrapper.addEventListener('click', (_event) => {
      if (optionsBlock.classList.contains('hidden')) {
        optionsBlock.classList.remove('hidden');
        optionsBlock.classList.add('absolute')
      } else {
        optionsBlock.classList.remove('absolute')
        optionsBlock.classList.add('hidden');
      }
    })

    // Set options-block width.
    document.getElementById('options-block').style.width = `${document.getElementById('selected-value-wrapper').getBoundingClientRect().width}px`;
  }

  global.abTestBasedOnBrowserLocale = function(locale) {
    // If the user has already closed the banner, we stop the execution.
    // Read localstorage and check if the user as already closed the banner or not.
    if (localStorage.getItem("modalClosed") === 'closedForever') {
      return;
    }

    if (locale === 'fr') {
      setTimeout(() => loadCatchTrafficModal('fr', { animation: 'fadein' }), 3000);
    } else if (locale === 'es') {
      setTimeout(() => loadCatchTrafficModal('es', { animation: 'fadein' }), 3000);
    } else if (locale === 'it') {
      setTimeout(() => loadCatchTrafficModal('it', { animation: 'fadein' }), 3000);
    } else if (locale === 'de') {
      setTimeout(() => loadCatchTrafficModal('de', { animation: 'fadein' }), 3000);
    } else if (locale === 'en') {
      setTimeout(() => loadCatchTrafficModal('en', { animation: 'fadein' }), 3000);
    } else {
      return;
    };
  }
})
